import { Injectable } from '@angular/core';
import { NotificationsService } from './notifications.service';
import { GlobalConstants } from '../constant/constant';
import { PendingPhoto } from '../models/photo/pending-photo';

/**
 * Helper service for shared time modal operations and alerts
 */
@Injectable({
  providedIn: 'root',
})
export class TimeModalHelperService {
  constructor(private notificationsService: NotificationsService) {}

  /**
   * Shows an odometer photo reminder alert if the user is tracking mileage or has provided
   * an odometer reading but hasn't provided a photo. Waits for user to dismiss before continuing.
   */
  async showOdometerPhotoReminderIfNeeded(trackMileage: boolean | null, odometerPhoto: PendingPhoto, odometerValue?: number | null): Promise<void> {
    const shouldShowReminder = (trackMileage === true || odometerValue != null) && !odometerPhoto;
    
    if (shouldShowReminder) {
      const alert = await this.notificationsService.showAlert({
        header: GlobalConstants.ODOMETER_PHOTO_REMINDER_HEADER,
        message: GlobalConstants.ODOMETER_PHOTO_REMINDER_MESSAGE,
        buttons: ['Dismiss']
      });     
      await alert.onDidDismiss();
    }
  }
}
